.f0{border-radius:0.5rem;}